import React from "react";
import { Headphones, Globe } from "lucide-react";
import { company } from "../mock";
import { SectionLabel, CountUp, OrangeButton, Reveal } from "../components/common";

const WhoWeAre = () => {
  return (
    <section className="relative py-24 bg-[#0B102D] overflow-hidden">
      <div className="max-w-[1320px] mx-auto px-5 grid lg:grid-cols-2 gap-14 items-center">
        <Reveal direction="left" className="relative">
          <img
            src="https://images.unsplash.com/photo-1721815693498-cc28507c0ba2?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
            alt="Completed Salmons Brothers building"
            className="rounded-lg w-full h-[440px] md:h-[540px] object-cover"
          />
        </Reveal>
        <Reveal direction="right">
          <SectionLabel light>Who We Are</SectionLabel>
          <h2 className="section-heading text-white text-4xl md:text-5xl mb-6">
            Building the next generation of quality homes
          </h2>
          <p className="text-white/70 leading-relaxed mb-8">{company.about3}</p>

          <div className="grid sm:grid-cols-2 gap-6 mb-9">
            <div className="bg-white/5 border border-white/10 rounded-lg p-6">
              <Globe className="text-[#CD0008] mb-3" size={30} />
              <div className="display-heading text-white text-4xl">
                <CountUp end={100} suffix="%" />
              </div>
              <p className="text-white/60 text-sm mt-1 uppercase tracking-wide">Family owned &amp; run</p>
            </div>
            <div className="bg-white/5 border border-white/10 rounded-lg p-6">
              <Headphones className="text-[#CD0008] mb-3" size={30} />
              <div className="display-heading text-white text-4xl">
                <CountUp end={60} suffix="+" />
              </div>
              <p className="text-white/60 text-sm mt-1 uppercase tracking-wide">Years of live support</p>
            </div>
          </div>

          <OrangeButton to="/contact">Read More</OrangeButton>
        </Reveal>
      </div>
    </section>
  );
};

export default WhoWeAre;
